export default {
	ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
	API_URL: import.meta.env.VITE_API_URL,
	DS_API_TOKEN: import.meta.env.VITE_DS_API_TOKEN,
	DS_API_URL_BUYER_CREDIT: import.meta.env.VITE_DS_API_URL_BUYER_CREDIT,
	SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
	TICKETING_URL: import.meta.env.VITE_TICKETING_URL,
	FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
	FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	FIREBASE_DATABASE_URL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
	FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	FIREBASE_MESSAGING_SENDER_ID: import.meta.env
		.VITE_FIREBASE_MESSAGING_SENDER_ID,
	FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
	FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
